function slideToggle(el, duration = 300) {
    if (el.classList.contains('sliding')) return; // prevent spam clicks
    el.classList.add('sliding');

    if (el.style.display === 'none' || getComputedStyle(el).display === 'none') {
        // Slide DOWN (show)
        el.style.display = 'block';
        el.style.overflow = 'hidden';
        el.style.height = '0';
        const targetHeight = el.scrollHeight + 'px';
        el.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => {
            el.style.height = targetHeight;
        });
        el.addEventListener('transitionend', () => {
            el.style.height = '';
            el.style.overflow = '';
            el.style.transition = '';
            el.classList.remove('sliding');
        }, { once: true });
    } else {
        // Slide UP (hide)
        el.style.overflow = 'hidden';
        el.style.height = el.scrollHeight + 'px';
        el.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.style.height = '0';
            });
        });
        el.addEventListener('transitionend', () => {
            el.style.display = 'none';
            el.style.height = '';
            el.style.overflow = '';
            el.style.transition = '';
            el.classList.remove('sliding');
        }, { once: true });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const boxes = document.querySelectorAll('.wp-block-wm-boxes-with-read-more');

    for ( let i = 0; i < boxes.length; i++ ) {
        boxes[i].querySelector('.wp-block-wm-boxes-with-read-more__toggle').addEventListener('click', () => {
            boxes[i].classList.toggle('-open');
            slideToggle(boxes[i].querySelector('.wp-block-wm-boxes-with-read-more__expandable'));
        });
    }
});